document.addEventListener("click", function (e) {
  if (e.target.matches(".request-quote-form .slide-form-submit")) {

    const country_code = e.target.closest("form").querySelector("#AddressCountryNew");
    const phone_number = e.target.closest("form").querySelector("#ContactForm-phone");
    debugger
    if (
      window.libphonenumber &&
      phone_number &&
      country_code &&
      phone_number.value
    ) {
      debugger;

      try {
        const phone_validate = window.libphonenumber.parsePhoneNumber(
          `+${country_code.value}${phone_number.value}`
        );
        const country_code_selected =
          country_code.options[country_code.selectedIndex].getAttribute(
            "data-countrycode"
          );

        if (phone_validate.country == country_code_selected) {
          submitForm(e.target.closest("form"));
          return true;
        } else {
          e.preventDefault();
          alert("Please enter a valid phone number !");
          return false;
        }
      } catch (event) {
        e.preventDefault();
        alert("Please enter a valid phone number !");
        return false;
      }
    } else {
      submitForm(e.target.closest("form"));
    }

    return true;
  }
});

function submitForm(form) {
  if (form) {
    form.querySelector("[data-submit-button]").click();
  }
}
